import { render, staticRenderFns } from "./BuchungSelect.vue?vue&type=template&id=0b8478c6&scoped=true"
import script from "./BuchungSelect.vue?vue&type=script&lang=js"
export * from "./BuchungSelect.vue?vue&type=script&lang=js"
import style0 from "./BuchungSelect.vue?vue&type=style&index=0&id=0b8478c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8478c6",
  null
  
)

export default component.exports